export default "__VITE_ASSET__CU$3bVCw__"